<div fxLayoutGap="0.5rem">
	<app-add-contact
		(contactAdded)="editedContact($event)"
		[carrierid]="carrierId"
		[contact]="contact"
		[isEdit]="true"
	>
	</app-add-contact>
	<mat-icon
		(click)="authorizeContact(contact)"
		style="cursor: pointer"
		matTooltip="Validate Contact"
	>
		verified_user
	</mat-icon>
	<mat-icon (click)="deleteContact(contact)" style="color: red; cursor: pointer" matTooltip="Delete Contact">
		delete_forever
	</mat-icon>

</div>
